import React from 'react';
import './services.css';

const Services = () => {
  const serviceCategories = [
    {
      title: "Growth Marketing Ecosystem",
      features: ["Social Media Marketing",  "Influencer & WhatsApp Marketing","Performance Marketing","SEO & SEM"],
      img: "/services-page/growth-system.png" // Replace with actual image path
    },
    {
      title: "Creative & Content Powerhouse",
      features: ["Content Creation (Reels/Videos)", "Graphic Designing", "Video Production", "Script Writing"],
      img: "/services-page/creative-house.png"
    },
    {
      title: "Digital Infrastructure",
      features: ["Website Design & Development", "E-Commerce Solutions",  "Mobile App Development","UI/UX Design"],
      img: "/services-page/digital-infrastructure.png"
    },
    {
      title: "Data Intelligence & Insights",
      features: ["Data Analytics",  "Customer Behavior Analysis","Sales Funnel Analysis","Campaign Tracking"],
      img: "/services-page/data-intelligence.png"
    },
    {
      title: "AI-Powered Growth Systems",
      features: ["AI Chatbot Development", "Marketing Automation", "Automated Lead Gen", "AI Content Creation"],
      img: "/services-page/Ai-systems.png"
    },
    {
      title: "Brand Strategy & Positioning",
      features: ["Brand Identity Design", "Personal Branding", "Campaign Planning", "Market Positioning"],
      img: "/services-page/brand-strategy.png"
    },
    {
      title: "Production & Visuals",
      features: ["Corporate Video Shoots", "Product Photography", "Podcast Production", "Studio Shoots"],
      img: "/services-page/production.png"
    },
    {
      title: "PR, Media & Offline Impact",
      features: ["Public Relations (PR)", "Offline Campaigns", "Outdoor Advertising", "Press Releases"],
      img: "/services-page/pr-media.png"
    },
    {
      title: "Revenue & Growth Systems",
      features: ["Lead Generation Services", "Sales Strategy Consulting", "CRM Setup", "Market Research"],
      img: "/services-page/revenue-system.png"
    }
  ];

  return (
    <div className="services-page">
      <div className="services-header">
        <div className="header-content">
          <h1>Our Expert Solutions</h1>
          <p>Everything you need to scale your brand in the digital age.</p>
        </div>
        <div className="header-decoration">
          {/* Paper plane graphic to match your reference */}
          <img src="/services-page/arrow-blue.png" alt="decoration" />
        </div>
      </div>

      <div className="services-grid">
        {serviceCategories.map((item, index) => (
          <div className="service-main-card" key={index}>
            <h3>{item.title}</h3>
            <ul className="service-features">
              {item.features.map((feat, i) => (
                <li key={i}>{feat}</li>
              ))}
            </ul>
            <div className="service-bottom">
              {/* <a href="/contact" className="learn-more-link">
                Learn More <span>→</span>
              </a> */}
              <div className="service-visual">
                <img src={item.img} alt={item.title} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;